const COMPLIANCE = {
    WIDGET_CONTENT_DETAILS_SELECT: {
        event: 'compliance',
        eventProperties: {
            description: 'User select view content from landing page widget',
            contentfulId: '',
            contentType: '',
        },
    },
    EXPORT_LAWS: {
        EVENT: 'Export Laws Modal',
        SUMMARY: 'Summary',
        WARNING: 'Warning',
    },
    HR_EXPERT_LINK_CLICKED: {
        event: 'HR Expert Link Clicked',
        eventProperties: {
            src: '',
            content_type: '',
            content_id: '',
        },
    },
    HR_CASE_SUBMITTED: {
        event: 'HR Case Submitted',
        eventProperties: {
            src: '',
            content_type: '',
            content_id: '',
        },
    },
    HR_CASE_SUBMITTED_TOP_NAV: {
        event: 'HR Case Submitted from Top Nav button',
        eventProperties: {
            source_url: '',
            case_id: '',
        },
    },
};

export default COMPLIANCE;
